import { render } from "./ButtonHelp.vue?vue&type=template&id=04721ae5&scoped=true"
import script from "./ButtonHelp.vue?vue&type=script&lang=js"
export * from "./ButtonHelp.vue?vue&type=script&lang=js"

import "./ButtonHelp.vue?vue&type=style&index=0&id=04721ae5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04721ae5"]])

export default __exports__